import pt from 'element-ui/lib/locale/lang/pt';

// 葡萄牙语(巴西)
export default {
  ...pt,
  layout: {
    title: 'Faça login com a ID do Uniportal',
    tip: 'Números de telefone não registrados serão registrados automaticamente após o login bem-sucedido',
    line: 'Outras opções de login',
  },
  button: {
    submit: 'Entrar/Registrar',
    getCode: 'Obter código',
    emailRegister: 'Registrar por e-mail',
    w3Login: 'Login da conta W3',
    employeeLogin: 'Login do Funcionário',
    passwordLogin: 'Senha Login',
    reSend: 'Reenviar',
    problem: 'Ajuda on-line',
    privacyPolicy: 'Declaração de privacidade',
  },
  placeholder: {
    phoneNumber: 'Número do celular',
    verificationCode: 'Código de verificação por SMS',
  },
  dialog: {
    imgCode: 'Insira os caracteres na imagem.',
    userAgreements: {
      header: 'Contrato de usuário e Declaração de privacidade',
      text1: 'Leia e concorde com a {privacy} e o {agreement}.',
      text2:
        'Ao acessar aplicativos da Huawei no exterior, as informações pessoais serão transferidas para as subsidiárias da Huawei no exterior para processamento. Para mais detalhes, consulte {privacy}',
    },
    crossBorder: {
      header: 'Dicas de autorização',
      text: 'O serviço local que você está usando não está na mesma região em que sua conta foi registrada. O acesso transfronteiriço às informações da conta requer a sua autorização.',
    },
    multiAccounts: 'Selecione uma conta.',
    agreeButton: 'Concordar e continuar',
    disagreeButton: 'Discordar',
    confirmButton: 'Confirmação',
    cancelButton: 'Cancelar',
    knowMe: 'Está bem',
  },
  toast: {
    hasSend: 'Código de verificação enviado.',
    wait: 'Um momento, por favor',
  },
  tooltip: {
    Huawei: 'Huawei ID',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'O código CAPTCHA não pode estar vazio.',
    'IDC-03-0002': 'O código CAPTCHA expirou.',
    'IDC-00-0004': 'Código CAPTCHA incorreto.',

    // 表单输入为空
    'IDC-01-00024': 'O código do país é necessário para verificar seu número de celular.',
    phoneNumberEmpty: 'Digite o número do celular.',
    'IDC-03-00033': 'Digite o código de verificação por SMS.',

    // 表单数据错误
    'IDC-02-00227': 'O número de telemóvel introduzido não corresponde ao país/região seleccionado',
    'IDC-02-00226': 'Código do país proibido',
    'IDC-02-00029': 'O código de verificação está incorreto ou expirou',
    'IDC-02-0013': 'Falha ao iniciar sessão por SMS . Código de verificação incorreto',
    'IDC-02-0020': 'Falha na verificação. Código de verificação incorreto.',
    'IDC-02-00028': 'O número de telemóvel deve ter entre 6 e 30 dígitos',
    'IDC-02-00012': 'Número de telemóvel incorreto',

    // 错误操作锁定
    accountLock:
      'Número de celular ou código de verificação incorreto. {number} tentativas restantes. | Número de celular ou código de verificação incorreto. {number} tentativas restantes.',
    accountLocked:
      'Muitas tentativas com falha. Tente novamente em {number} segundos. | Muitas tentativas com falha. Tente novamente em {number} segundos.',
    operationRisk:
      'A operação atual é um risco de segurança . Tente novamente em {number} segundos .',

    // 频繁操作
    'IDC-02-00038': 'Tente novamente após 60 segundos.',
    'IDC-02-00064':
      'O número de vezes que você enviou o código de verificação SMS é muito frequente . Por favor , tente novamente em 24 horas !',
    'IDC-02-00211': 'A operação atual tem um risco de segurança . Tente novamente mais tarde .',
    'IDC-02-00212':
      'O seu número de telemóvel enviou códigos de verificação SMS com muita frequência . Tente alterar o número de telemóvel ou tente novamente em 24 horas !',
    'IDC-02-00213':
      'O número de vezes que você enviou o código de verificação SMS é muito frequente . Por favor , tente novamente em 24 horas !',
    'IDC-02-00215':
      'O seu número de telemóvel envia códigos de verificação por SMS com muita frequência. Tente alterar o seu número de telemóvel , escolha outro método de verificação ou tente novamente 24 horas depois .',
    'IDC-02-00228':
      'O número de vezes que você enviou o código de verificação por SMS é muito frequente . Tente novamente em 1 hora !',
    'IDC-02-00092': 'A operação atual é muito frequente. Tente novamente 24 horas depois.',

    // 请求异常
    'IDC-10-00400': 'Exceção de solicitação do cliente',
    'IDC-10-00500': 'Erro interno do sistema ',
    'IDC-02-00264': 'Solicitações de acesso não autorizadas são proibidas',
    'IDC-02-00063': 'Parâmetro inválido',
    'IDC-03-0007':
      'A operação atual apresenta um risco de segurança e o registro está temporariamente indisponível.', // 机翻
    'IDC-03-00057': 'A operação atual tem riscos de segurança.',

    // 页面过期
    'IDC-00-00017': 'A página expirou.',
  },

  // 注册协议、隐私声明对话框
  backButton: 'Voltar',
  closeButton: 'Fechado',

  // 滑块验证相关：
  resourceReqFailed: 'Falha na solicitação de recurso. Atualize a página e tente novamente.',
  verifyFailedAndPlsRetry: 'Falha na autenticação, tente novamente',
  serviceErrAndPlsRetry: 'Exceção de serviço. Tente novamente.',
  learnMore: 'Saiba mais',
  cookieBannerText:
    'Este site utiliza a funcionalidade de cookies para lhe proporcionar a melhor experiência de utilizador.',
};
